import { render } from "./AddSectionDialog.vue?vue&type=template&id=ae94bdd4&scoped=true"
import script from "./AddSectionDialog.vue?vue&type=script&lang=js"
export * from "./AddSectionDialog.vue?vue&type=script&lang=js"

import "./AddSectionDialog.vue?vue&type=style&index=0&id=ae94bdd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae94bdd4"]])

export default __exports__